const answers = {
  'ok': {
    value: 'Давай сделаем это',
    title: 'Давай сделаем это :raised_hands:'
  },
  'yes': {
    value: 'Да',
    title: 'Да'
  },
  'no': {
    value: 'Нет',
    title: 'Нет'
  },
  'now': {
    value: 'Сейчас!',
    title: 'Сейчас!'
  },
  'term1-3': {
    value: '1-3 месяца',
    title: '1-3 месяца'
  },
  'term3-6': {
    value: '3-6 месяцев',
    title: '3-6 месяцев'
  },
  'term6-12': {
    value: '6-12 месяцев',
    title: '6-12 месяцев'
  },
  'term12-p': {
    value: 'через 1-2 года',
    title: 'через 1-2 года'
  },
  'budget2': {
    value: 'до 2 млн.',
    title: 'до 2 млн.'
  },
  'budget2-5': {
    value: '2,5 – 5 млн.',
    title: '2,5 – 5 млн.'
  },
  'budget5-7': {
    value: '5 – 7 млн.',
    title: '5 – 7 млн.'
  },
  'budget7-10': {
    value: '7 – 10 млн.',
    title: '7 – 10 млн.'
  },
  'budget10-15': {
    value: '10 – 15 млн.',
    title: '10 – 15 млн.'
  },
  'budget15-25': {
    value: '15 – 25 млн.',
    title: '15 – 25 млн.'
  },
  'budget25-50': {
    value: '25 – 50 млн.',
    title: '25 – 50 млн.'
  },
  'budget50-100': {
    value: '50 – 100 млн.',
    title: '50 – 100 млн.'
  },
  'budget100-p': {
    value: '100+ млн.',
    title: '100+ млн.'
  },
  'studio': {
    value: 'Студия',
    title: 'Студия'
  },
  'room1': {
    value: '1-комнатная',
    title: '1-комнатная'
  },
  'room2': {
    value: '2-комнатная',
    title: '2-комнатная'
  },
  'room3': {
    value: '3-комнатная',
    title: '3-комнатная'
  },
  'room4': {
    value: '4-комнатная',
    title: '4-комнатная'
  },
  'room5': {
    value: '5-комнатная',
    title: '5-комнатная'
  },
  'central-district': {
    value: 'Центральный',
    title: 'Центральный'
  },
  'north-distrcit': {
    value: 'Северный',
    title: 'Северный'
  },
  'north-east-district': {
    value: 'Северо-Восточный',
    title: 'Северо-Восточный'
  },
  'east-district': {
    value: 'Восточный',
    title: 'Восточный'
  },
  'south-east-distrcit': {
    value: 'Юго-Восточный',
    title: 'Юго-Восточный'
  },
  'south-distrcit': {
    value: 'Южный',
    title: 'Южный'
  },
  'south-west-distrcit': {
    value: 'Юго-Западный',
    title: 'Юго-Западный'
  },
  'west-district': {
    value: 'Западный',
    title: 'Западный'
  },
  'north-west-distrcit': {
    value: 'Северо-Западный',
    title: 'Северо-Западный'
  },
  'zelenogradskiy-distrcit': {
    value: 'Зеленоградский',
    title: 'Зеленоградский'
  },
  'novomoskovskiy-distrcit': {
    value: 'Новомосковский',
    title: 'Новомосковский'
  }
}

export default answers



// WEBPACK FOOTER //
// ./selectors/data/answers.js